import { Config } from './types';

export const beta: Config = {
  CONSENT_MANAGER_SCRIPT_URL:
    'https://d1ber8az9zrhox.cloudfront.net/common/static/consent-manager.js',
  HEAP_ID: '1144240245',
  RWA_CLIENT_ID: 'RingtercomCompatibilityChecker',
  RWA_AWS_REGION: 'us-west-2',
  RWA_EVENT_STREAM_ENDPOINT: 'https://eventstream.dev.ring.com/anon',
  RWA_GROUP: 'client.device',
  RWA_SUBGROUP: 'ring.site.webapp',
};
